<template>
    <div class="series-main">
        <div class="series_top">
            <div class="flex-row series_top_left">
                <div class="series_top_title">生成章节大纲</div>
                <!-- v-if="editType !== 1" -->
                <div class="cursor_1 series_top_tip" @click="openTip">
                    <img src="@/assets/image/icon_tip.png" class="t-m-r-5" width="18" height="18" alt="">
                    参考格式
                </div>
            </div>
            <textLoading v-if="streamStatus"></textLoading>
            <div class="cursor_1 series_top_center" v-if="!streamStatus && editType == 2" @click="changeOutline">换一换
            </div>
            <div class="series_top_right">
                <div class="cursor_1 copyText t-m-r-10" @click="copyInnterText">复制内容</div>
                <div class="series_top_num" v-if="aiCreateContent && noveloutline.length > 0">字数 {{ outlineNum +
                    aiCreateContent.length }}</div>
                <div class="series_top_num" v-if="!aiCreateContent && noveloutline.length > 0">字数 {{ outlineNum }}</div>
                <div class="series_top_num" v-if="aiCreateContent && !noveloutline.length">字数 {{ aiCreateContent.length
                    }}</div>
            </div>
        </div>
        <!-- 分卷内容 -->
        <div class="series_center" ref="editorOutline1" :class="isEditorMode ? '' : 'noEditor'">

            <!-- 第一次的手写分卷 -->
            <!-- <div class="series_center_text" v-if="editType === 1" :class="isEditorMode ? '' : 'noClick'">
                <el-input v-model="initWritForm.title" placeholder="请输入分卷标题" show-word-limit maxlength="50"></el-input>
                <el-input v-model="initWritForm.content" type="textarea" placeholder="请输入分卷内容" show-word-limit
                    maxlength="2000" :autosize="{ minRows: 6 }"></el-input>
            </div> -->
            <!-- 生成 -->
            <div v-if="editType == 2" :class="isEditorMode ? '' : 'noClick'">
                <editorLongChapterOutlineList readonly :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div>
            <!-- 编辑 -->
            <div v-if="editType == 3" :class="isEditorMode ? '' : 'noClick'">
                <editorLongChapterOutlineList readonly :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div>
            <!-- 续写分卷 -->
            <div v-if="editType == 4" :class="isEditorMode ? '' : 'noClick'">
                <editorLongChapterOutlineList readonly :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div>
            <!-- 不用json方式，直接用打印机的方式显示 -->
            <div v-if="aiCreateContent">
                <div style="white-space: pre-line">
                    {{ aiCreateContent }}
                </div>
            </div>
        </div>
        <div class="series_bottom">
            <div v-if="!isLook" class="t-m-r-10">
                <el-button type="warning" @click="openEditor" v-if="!isEditorMode">编辑</el-button>
                <el-button type="warning" @click="save" plain v-if="isEditorMode">提交</el-button>
                <el-button type="warning"
                    v-if="[1, 2].includes(editType) && noveloutline.length > 0 && !streamStatus && isShowZG"
                    @click="next" :loading="nextChapterLoading">下一步生成章纲</el-button>
            </div>
            <div>
                <el-button type="warning" @click="save" plain v-if="ifheadEdit && isEditorMode">提交</el-button>
                <el-button type="warning" v-if="noveloutline.length > 0 && !streamStatus"
                    @click="outlineEditorClick">大纲修订</el-button>
            </div>
        </div>
        <!-- 停止生成按钮 -->
        <AIStopCreate :hide="streamStatus"></AIStopCreate>
        <!-- 参考格式弹框 -->
        <tipPopup ref="tipPopup"></tipPopup>
        <!-- 警告提示框 -->
        <warnPopup ref="warnPopup"></warnPopup>
        <!-- <delPopup @confirm="confirmOutline"></delPopup> -->
        <!-- 换一换要求 -->
        <textRequire ref="textRequire" placeholder="请输入你的要求（无要求可直接点立即生成哦）"></textRequire>
        <!-- 编辑 -->
        <editorLongSeriesWrite ref="seriesWrite" @appendSeriesText="appendSeriesText"></editorLongSeriesWrite>
        <!-- 大纲修订 -->
        <editorLongOutlineCorrect ref="outlineCorrect" @replace="replaceOutline"></editorLongOutlineCorrect>
    </div>

</template>
<script>
import tipPopup from '@/components/tip_popup.vue'
import warnPopup from '@/components/warn_popup.vue'
import editorLongChapterOutlineList from '@/components/long_novel/chapter/editor_long_chapter_outlineList.vue'
import editorLongSeriesWrite from '@/components/long_novel/chapter/editor_long_chapter_write.vue'
import editorLongOutlineCorrect from '@/components/long_novel/chapter/editor_long_outline_correct.vue'
import textRequire from '@/components/text_require.vue'// 要求
import { EventBus } from '@/utils/eventBus';
import delPopup from '@/components/del_popup.vue';
import textLoading from '@/components/text_loading.vue';
import { EncryptionUtil } from '@/utils/encrypt'
import { copy } from '@/utils/utils'
import api from '@/api/api';
import lNApi from '@/api/longNovel';
export default {
    components: {
        tipPopup,
        editorLongChapterOutlineList,
        editorLongOutlineCorrect,
        editorLongSeriesWrite,
        warnPopup,
        delPopup,
        textLoading,
        textRequire,
    },
    data() {
        return {
            editType: null, //1我有大纲手动输入 2Ai生成 3编辑大纲 4续写章节
            ifheadEdit: false, //  true 修改接口，false 新增接口
            ifSave: false, //是否保存
            outlineNum: 0, //大纲字数
            // 手动输入提示词
            handPlaceholder: '请长按粘贴或者输入您的大纲:大纲格式请参考”官方动态-我有大纲格式标准”',
            noveloutline: [], //小说大纲
            outlineItem: '', //Ai生成大纲
            // streamCapture: [-1, -1],
            // streamStatus: false, //流式请求
            // streamIndex: 0, //流式请求下标
            // debounceTimer: null, //防抖定时器
            textrequire: '',//作品要求
            isEditorMode: false, //false显示编辑 true显示保存
            isStop: false, //是否停止
            checked: false, //全选、反选
            isAiCreate: false,//是否ai去生成 true进入页面立即生成，false 表示不会刷新页面就生成
            hideEditorBtn: false,//false 默认不隐藏， true隐藏
            initWritForm: { // 第一次手写的对象内容
                title: '',
                outline: ''
            },
            isLook: false, //只是查看
            isShowZG: false
        }
    },
    mounted() {
        //换一换，下一步都是这个去监听
        EventBus.$on('getRequire', (item, type) => {
            console.log('监听换一换的作品要求=', item);
            this.noveloutline = []
            this.textrequire = item
            //换一换 初始化取消ai生成的状态
            this.isStop = false
            this.isEditorMode = true
            this.aiCreateContent = ''
            this.createOutline()
        })
    },
    created() {
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        console.log('章节大纲页面=', editItem)
        if (editItem) {
            this.editType = editItem.editType;
            this.isAiCreate = editItem.isAiCreate === true ? true : false;
            this.isLook = editItem.isLook === true ? true : false
            this.isShowZG = editItem.isShowZG
            if (this.editType === 1) {
                this.ifSave = false
                //我有大纲，进来可以先编辑
                this.isEditorMode = true
                this.openTip()
            } else if (this.editType === 2) {
                // this.currSeries()
                if (editItem.isAiCreate) {
                    //这里改变状态，如果重新刷新了页面就会提示
                    editItem.isAiCreate = false
                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                    //首次ai生成大纲，进来可以先编辑
                    this.isEditorMode = true
                    this.ifSave = false
                    this.createOutline()
                } else {
                    this.$notify({
                        title: '提示',
                        message: '请使用换一换来生成AI章节大纲',
                        duration: 5000,
                        type: 'warning'
                    });
                }

            } else if (this.editType === 3) {
                if (this.isLook) {
                    this.isEditorMode = true
                }
                this.getOutline()
            }
            //  else if (this.editType === 4) {
            //     this.getOutline()
            //     if (editItem.isAiCreate) {
            //         //这里改变状态，如果重新刷新了页面就会提示
            //         editItem.isAiCreate = false
            //         sessionStorage.setItem('editItem', JSON.stringify(editItem))
            //         //首次ai生成大纲，进来可以先编辑
            //         this.isEditorMode = true
            //         setTimeout(() => {
            //             this.continuedWriting()
            //         }, 0);
            //     } else {
            //         this.isEditorMode = true
            //         this.$notify({
            //             title: '提示',
            //             message: '请使用AI续写大纲进行续写',
            //             duration: 5000,
            //             type: 'warning'
            //         });
            //     }
            // }
        } else {
            // this.$message.warning('不支持多开页面进行操作')
            // setTimeout(() => {
            //     window.location.href = 'about:blank'; // 跳转到空白页
            // }, 500);

        }
    },
    beforeDestroy() {
        EventBus.$off('getRequire')
        this.clearTimer()
    },
    methods: {
        //销毁定时器
        clearTimer(status) {
            console.log('进来了销毁定时器')
            if (status) {
                this.isStop = true
                // this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                this.parseToFormData()
            }
            this.mixinClearTimer();
            // this.outlineItem = ''
            // this.streamCapture = [-1, -1]
            // clearTimeout(this.debounceTimer)
            // this.streamStatus = false
            // this.streamIndex = 0
            // sessionStorage.removeItem('streamStatus');
        },
        parseToFormData() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            this.parseJSONToFormData(this.aiCreateContent, {
                ycCollback: (resultText) => {
                    this.noveloutline = resultText.chapters.map(item => ({
                        title: item.title,
                        outline: item.content
                    }))
                    this.aiCreateContent = ''
                    this.toScrollRef(this.scrollerRef)
                },
                wcCollback: () => {
                    this.$confirm('解析出错，请手动上传处理', '提示', {
                        confirmButtonText: '去处理',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const content = this.aiCreateContent
                        this.aiCreateContent = ''
                        this.$router.replace({ path: '/chapterOutlineImport', query: { novelInfo: EncryptionUtil.encrypt(editItem.novelInfo), successNovelId: editItem.novelInfo.id, series: EncryptionUtil.encrypt(editItem?.series), seriesId: editItem?.series.id, aiCreateText: EncryptionUtil.encrypt(content) } })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消手动处理'
                        });
                        this.aiCreateContent = ''
                    });
                }
            })
        },
        //打开格式提示
        openTip() {
            this.$nextTick(() => {
                this.$refs.tipPopup.openPopup();
            })
        },
        //大纲修订
        outlineEditorClick() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            lNApi.longChapterList({ seriesId: editItem.seriesId }).then((res) => {
                if (res.code === 200) {
                    if (res.data) {
                        let content = res.data.length > 0 ? res.data : this.noveloutline
                        this.$refs.outlineCorrect.open({ content, seriesId: editItem.seriesId, novelId: editItem.id, seriesNum: editItem.seriesNum })
                    }
                }
            })
        },
        //换一换ai生成
        changeOutline() {
            this.$refs.textRequire.openPrompt('lnovel_outline_1', '')
        },
        //Ai生成大纲 和 换一换
        createOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                novelId: editItem.id,
                series: editItem.seriesNum,
                platform: 1,
                requirement: this.textrequire ? this.textrequire : ''
            }
            this.AIWrite({
                length: '长',
                haveId: true,
                // type: 'lnovel_outline',
                type: 'i_lnovel_outline',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    sessionStorage.setItem('ifEditor', true)
                    this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                    localStorage.setItem('AICreateId', res.data)
                    // this.getStreamContent(res.data)
                    this.getComStreamContent(res.data, {
                        scrollRef: this.scrollerRef,
                        success: () => {
                            this.parseToFormData()
                        }
                    })
                },
                warn: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                }
            })
            // lNApi.longNovelHelpWriteId('lnovel_outline',
            //     {
            //         novelId: editItem.id,
            //         series: editItem.seriesNum,
            //         platform: 1,
            //         requirement: this.textrequire ? this.textrequire : ''
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         sessionStorage.setItem('ifEditor', true)
            //         this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.streamStatus = false
            //         sessionStorage.removeItem('streamStatus');
            //         this.$message.warning(res.msg)
            //     }
            // }).catch(() => {
            //     this.streamStatus = false
            //     sessionStorage.removeItem('streamStatus');
            // })
        },
        //item 续写有内容，没有则是编辑后需要刷新
        appendSeriesText(item) {
            if (item) {
                console.log('编辑返回的数据=', item)
                this.isEditorMode = true
                if (this.noveloutline.some((s, si) => si === item.seriesIndex)) {
                    this.noveloutline = this.noveloutline.map((f, i) => {
                        //如果存在就替换
                        if (i === item.seriesIndex) {
                            console.log('编辑')
                            delete item.seriesIndex
                            f = item
                        }
                        return f
                    })
                }
                // else {
                //     console.log('添加续写')
                //     delete item.seriesIndex
                //     this.noveloutline.push(item)
                // }
            } else {
                this.$message.success('修改成功！')
                const editItem = JSON.parse(sessionStorage.getItem('editItem'));
                editItem.backNum = 1
                this.ifSave = true
                //保存大纲后，不可编辑
                this.isEditorMode = true
                //保存后可以出现手动续写和ai编辑
                this.isStop = false
                //ai生成完成隐藏编辑里面的按钮
                this.hideEditorBtn = false
                sessionStorage.setItem('editItem', JSON.stringify(editItem))
                sessionStorage.removeItem('streamStatus');
                sessionStorage.setItem('ifEditor', false)
                this.getOutline()
            }

        },
        //章节列表 下面的 续写章节
        continuedWriting() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let data = {
                plot: editItem.plot,
                chapter: editItem.chapter,
                novelId: editItem.novelInfo.id,
            }
            EventBus.$emit('handwriting', false, '')
            this.getContinued(data)
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    this.outlineItem += item
                                    this.streamCapture[0] = this.outlineItem.indexOf('{');
                                    this.streamCapture[1] = this.outlineItem.indexOf('}');

                                    if (this.streamCapture[0] !== -1 && this.streamCapture[1] !== -1) {
                                        const jsonStr = this.outlineItem.substring(this.streamCapture[0], this.streamCapture[1] + 1)
                                        this.outlineItem = this.outlineItem.replace(jsonStr, '')
                                        let chapterObj = this.escapeControlCharacters(jsonStr)
                                        const chapter = JSON.parse(chapterObj);
                                        let obj = {
                                            title: chapter.t,
                                            outline: chapter.p
                                        }
                                        this.noveloutline.push(obj);
                                        this.scrollToBottom(); // 调用滚动方法
                                        this.streamCapture = [-1, -1]
                                    }
                                }
                            });
                            if (res.data[res.data.length - 1] === '[DONE]') {
                                this.streamIndex = 0
                                this.clearTimer()
                                //刷新用户信息-基础会员字符刷新
                                this.getUserInfo()
                                return
                            }
                            this.getStreamContent(id)
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.streamStatus = false
                });
            }, 500);
        },
        escapeControlCharacters(str) {
            return str.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
        },
        // 滚动到内容底部
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.editorOutline1;
                if (container) {
                    container.scrollTop = container.scrollHeight; // 设置滚动位置到底部
                }
            });
        },
        //获取大纲内容
        getOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            lNApi.longChapterList({ seriesId: editItem.seriesId }).then((res) => {
                if (res.code == 200) {
                    this.noveloutline = res.data
                    //如果是续写篇章先让内容滚动到最下面，然后生成的时候进行拼接
                    if (this.editType === 4) {
                        this.scrollToBottom()
                    }
                }
            })

        },

        //获取大纲字数
        getoutlineNum(item) {
            this.outlineNum = item.num
            this.noveloutline = item.list
        },
        //手动续写
        handwriting(content = '') {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            // this.$refs.tipPopup.openPopup();
            this.hideEditorBtn = false
            this.$refs.seriesWrite.openPopup();
            // EventBus.$emit('handwriting', true, content)
        },
        //AI续写
        aiWriting() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.isEditorMode = true
            this.$refs.outlineContinuous.openPopup();
        },
        //打开编辑
        openEditor() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            sessionStorage.setItem('ifEditor', true)
            this.isEditorMode = true
            this.ifSave = false
        },

        //大纲修订替换
        replaceOutline(data) {
            this.isStop = false
            this.ifheadEdit = [1, 2].includes(this.editType) ? false : true
            this.isEditorMode = true
            this.noveloutline = data.list || []
            this.outlineNum = data.num || 0
        },
        //AI续写分卷
        getContinued(continued) {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                nextPlot: continued.plot,
                num: continued.chapter,
                novelId: editItem.novelInfo.id,
            }
            this.AIWrite({
                length: '长',
                haveId: true,
                type: 'i_series_continue',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    localStorage.setItem('AICreateId', res.data)
                    this.hideEditorBtn = true
                    this.getStreamContent(res.data)
                },
                warn: (res) => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                }
            })
            // lNApi.longNovelHelpWriteId('series_continue',
            //     {
            //         nextPlot: continued.plot,
            //         num: continued.chapter,
            //         novelId: editItem.novelInfo.id,
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         // console.log(res)
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         localStorage.setItem('AICreateId', res.data)
            //         this.hideEditorBtn = true
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.streamStatus = false
            //         sessionStorage.removeItem('streamStatus');
            //         this.$message.warning(res.msg)
            //     }
            // }).catch(() => {
            //     this.streamStatus = false
            //     sessionStorage.removeItem('streamStatus');
            // })
        },
        //下一步生成章纲
        next() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            if (this.noveloutline.length) {
                this.ifheadEdit = false
                this.nextChapterLoading = true
                let editItem = JSON.parse(sessionStorage.getItem('editItem'))
                //提交大纲内容
                this.confirmOutline(true, () => {
                    //进行下一步章纲操作
                    let chapterList = []
                    lNApi.longChapterList({ seriesId: editItem.seriesId }).then((res) => {
                        if (res.code == 200) {
                            chapterList = res.data
                            if (!res.data.length) {
                                this.$message.warning('请先保存后在进行下一步生成章纲操作')
                                return
                            }
                            let edit = {
                                id: editItem.id,
                                novelInfo: editItem.novelInfo,
                                editText: 3,
                                seriesId: editItem.seriesId,
                                series: editItem.series,
                                seriesNum: editItem.seriesNum,
                                chapterId: chapterList[0].id,
                                chapter: chapterList[0].chapter,
                                chapterName: chapterList[0].title,
                                // textId: this.chapterList[i].textId,
                            };
                            sessionStorage.setItem('editItem', JSON.stringify(edit));
                            this.nextChapterLoading = false
                            this.$router.replace({ path: '/seriesChapterEditor' });
                        }
                    })
                })



            } else {
                this.$notify({
                    title: '提示',
                    message: `没有大纲内容`,
                    // duration: 0,
                    type: 'warning'
                });
            }
        },
        //保存大纲
        confirmOutline(isNextChapter, callback) {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            //初次添加 ai生成分卷、我有大纲
            if (!this.noveloutline.length) {
                this.$message.warning('没有大纲章节内容');
                return
            }
            const apiName = this.ifheadEdit ? 'longNovelEditor' : 'longChaptersInsert'
            lNApi[apiName]({
                seriesId: editItem.seriesId,
                chapters: this.noveloutline
            }).then((res) => {
                if (res.code == 200) {
                    const editItem = JSON.parse(sessionStorage.getItem('editItem'));
                    editItem.backNum = 1
                    if ([1, 2].includes(this.editType)) {
                        //如果执行下一步生成章纲，反之直接跳到短剧小说列表页面
                        if (isNextChapter) {
                            callback && callback()
                            return
                        }
                    }
                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                    this.$message.success('操作成功！');
                    sessionStorage.removeItem('streamStatus');
                    sessionStorage.setItem('ifEditor', false)
                    this.$router.push({ path: '/seriesList', query: { novelInfo: EncryptionUtil.encrypt(editItem.novelInfo), successNovelId: editItem.novelInfo.id } })
                    // this.$router.replace({ path: '/chapterList', query: { seriesInfo: EncryptionUtil.encrypt(editItem.series), novelInfo: EncryptionUtil.encrypt(editItem.novelInfo) } })
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 保存大纲
        save() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            if (this.isStop) {
                this.cancelAi().then(() => {
                    this.confirmOutline()
                })
            } else {
                this.confirmOutline()
            }
        },
        //删除大纲
        delOutline(data) {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = ''
            if (data.index === this.noveloutline.length - 1) {
                text = `是否需要删除从第${data.index + 1}章节，删除后无法恢复，请慎重操作`
            } else {
                text = `是否需要删除从第${data.index + 1}章节到后面所有的章节，且无法恢复，请慎重操作`
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //如果当前有id说明是已经存在的，如果没有id说明是刚ai生成的
                // console.log('data=', data)
                if (data.id !== -1) {
                    // lNApi.delNovelOutline({ id: data.id }).then(res => {
                    //     if (res.code === 200) {
                    //         this.$message.success('删除成功')
                    //         this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                    //         this.novleEmptyIsToPath()
                    //     }
                    // })
                } else {
                    this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                    this.$message.success('删除成功')
                }
            })
        },
        // 复制正文
        async copyInnterText() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = this.noveloutline.reduce((count, item) => {
                return count + '\n' + item.title + '\n' + item.outline
            }, '')
            const success = await copy(text);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        //修改
        editSeries(data) {
            console.log('data=', data)
            this.$refs.seriesWrite.editInfo({ ...data.item, seriesIndex: data.index, name: '编辑大纲' })
        },
        //查看当前分卷
        // currSeries(){
        //     const editItem = JSON.parse(sessionStorage.getItem('editItem'));
        //     lNApi.currSeries({id:editItem.id}).then(res=>{

        //     })
        // }
    }
}
</script>
<style lang="scss" scoped>
.series-main {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.series_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 67px;
    padding: 0 40px;
    border-bottom: 1px solid #e6ebf0;
    flex-shrink: 0;

    .series_top_left {
        .series_top_title {
            font-weight: 700;
            font-size: 19px;
            color: #111;
            margin-right: 10px;
        }

        .series_top_tip {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #333;
        }
    }

    .series_top_center {
        font-size: 15px;
        color: #444;
    }

    .series_top_right {
        display: flex;
        align-items: center;

        .series_top_num {
            font-size: 15px;
            color: #444;
        }
    }
}

.series_center {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    padding: 15px 20px;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover();
    }

    .series_center_text {
        ::v-deep(.el-input__inner) {
            border: 0;
        }

        ::v-deep(.el-textarea__inner) {
            border: 0;
        }
    }
}

.series_bottom {
    flex-shrink: 0;
    height: 69px;
    border-top: 1px solid #e6ebf0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>